export default __webpack_public_path__ + "static/media/IMG_037_finished.8d5da792.jpg";